import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'

import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import ChecklistSelect from '../../../../../../containers/checklists/select/ChecklistSelect'
import { SwitchWithLabel } from '../../../../../../components/form/Switch'

const CompleteServiceOrdersSentence = () => {
  const { t } = useTranslation('triggers')
  const [open, setOpen] = React.useState()
  const { form } = useFormState()

  const dataToChange = () => {
    let text = ''
    if (form.payload?.days) text += t('completeServiceOrders.moreThanDays', { days: form.payload.days })
    if (form.payload?.checklists && form.payload?.checklists.length)
      text += t('completeServiceOrders.withChecklists', {
        checklists: form.payload.checklists.map(c => c.name).join(', ')
      })
    if (form.payload?.fireAutomations) text += t('completeServiceOrders.shouldFireAutomations')

    if (!text) text = '_______'

    return text
  }

  return (
    <>
      <EditableSentence label={dataToChange()} truncate={40} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Title size="h5" bold>
          {t('actions.complete_service_orders')}
        </Title>
        <Text size="xsmall">{t('completeServiceOrders.configureAutomationBehavior')}</Text>
        <Separator weight={4} />

        <Grid paddingGutter={0.5} wrap>
          <Col width="50%">
            <FormItem label={t('completeServiceOrders.moreThanDaysLabel')} path={['payload', 'days']} />
          </Col>
          <Col width="50%">
            <FormItem
              label={t('triggers:fields.checklist')}
              path={['payload', 'checklists']}
              Input={ChecklistSelect}
              filter={{ usages: ['serviceOrder'], includeDisabled: false }}
              multiple
            />
          </Col>
          <FormItem
            path={['payload', 'fireAutomations']}
            label={t('completeServiceOrders.fireAutomations')}
            Input={SwitchWithLabel}
            ignoreLabel
          />
        </Grid>
        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default CompleteServiceOrdersSentence
